import { Option } from "../../option.model";
import { IProvideOptions } from "./options-provider.interface";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { EnumsService } from "projects/borrower-app/src/app/services/enums.service";

@Injectable()
export class OccupancyOptionsProvider implements IProvideOptions {

  constructor(
    private readonly _enumsService: EnumsService
  ) {
  }

  getOptions(): Observable<Option[]> {
    return of(this._enumsService.propertyWillBeTypes.map(lp => {
      return new Option(lp.name, lp.name, "", lp.value || "", lp.iconName);
    }))
  }
}
